/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Register_TitleInputs */

const de_login_register_title = /** @type {(inputs: Login_Register_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmelden oder Registrieren`)
};

/** @type {(inputs: Login_Register_TitleInputs) => LocalizedString} */
const en_login_register_title = de_login_register_title;

/**

* @param {Login_Register_TitleInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const login_register_title = /** @type {((inputs?: Login_Register_TitleInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Register_TitleInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_login_register_title(inputs)
	return en_login_register_title(inputs)
});